export default __webpack_public_path__ + "static/media/empty_house.f5f5e128.svg";